import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl32FormDataToModel,
  convertModelToBefehl32FormData
} from './converters'
import { BefehlFormWrapper, BefehlFormProps } from '../Generic'
import { Befehl32 } from '../../../models'
import Auftrag32_10Form from './Auftrag32_10Form'

import { Befehl32FormData, createBefehl32FormValidationSchema } from './schema'
import { useBefehlForm } from '../../../hooks'

/**
 * Main form component for Befehl 32
 */
export default function Befehl32Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-32-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl32>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl32FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl32FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl32FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl32FormData) => {
      const updatedBefehl = convertBefehl32FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl32FormData>
      befehlKennung="32"
      title={t('befehle.32.description')}
      readOnly={readOnly}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 32.10 */}
      <Auftrag32_10Form
        befehlKennung={'32'}
        fieldPrefix={'auftrag_32_10'}
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-32-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
